import type { MutableRefObject } from "react";
import { useEffect, useState } from "react";
import debounce from "lodash.debounce";

const SCROLL = "scroll";
const DELAY = 50;

export default function useSticky(
  offsetY: number,
  stopEl?: MutableRefObject<HTMLElement>
) {
  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = debounce(() => {
      if (window.scrollY < offsetY) {
        setSticky(false);
      } else {
        /*
      else if (stopEl && window.scrollY > stopEl.current.offsetTop) {
        setSticky(false);
      } */
        setSticky(true);
      }
    }, DELAY);

    window.addEventListener(SCROLL, handleScroll);

    return () => window.removeEventListener(SCROLL, handleScroll);
  }, [offsetY, stopEl]);

  return isSticky;
}
